<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{addEditHeader}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                    outlined
                    name="input-7-4"
                  :label="$t('รหัสการสั่งตรวจ')"
                  v-model="newResultItemID"
                  :disabled="isEdit"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field class="ma-0 pa-0" 
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อการสั่งตรวจ')"
                  v-model="newResultItemDesc"
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0"
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อเล่น')"
                  v-model="newNickName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select :items="uomList" v-model="newUom" item-text="uom_desc" item-value="uom"
                  :label="$t('WpResultItem.uom')" persistent-hint single-line outlined dense hide-details>
                </v-select>
              </v-col> 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="addTestItem(newResultItemID,newResultItemDesc,newNickName,newUom)">{{$t('save')}}</v-btn>
            <v-btn outlined color="error" @click="closeAddnew">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="result_item_skey"
      class="fill-height"
    > 
      <template v-slot:item.data-table-no="{ item, index }">
        {{index + 1}}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{$t('WpResultItem.ResultItemTitle')}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" style="text-transform: capitalize" @click="ImportExcelToDbConfirm()">
            {{$t('import')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="ExportExcelLab">
            {{$t('export excel')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>    -->
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newItem()">
            <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpResultItem.buttonNewResultItem')}}
          </v-btn>
          <!-- <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('WpResultItem.buttonDeleteResultItem')}}
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveWpResultItem(appName)">
            <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import { VueEditor, Quill } from 'vue2-editor'
/* import { consoleLog } from '../node_modules-/echarts/lib/util/log' */
var Keyboard = Quill.import('modules/keyboard')
class CustomKeyboard extends Keyboard {
  static DEFAULTS = {
    ...Keyboard.DEFAULTS,
    bindings: {
      ...Keyboard.DEFAULTS.bindings,
      ['list autofill']: undefined,
    }
  }
}
Quill.register('modules/keyboard', CustomKeyboard)
export default {
  components: {
    VueEditor,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
      },
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogLanguage: false,
        dialogAddOrderItem: false,
        dialogAddResultItem: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      uomList: [],
      progressMessage: '',
      languages: [],
      languageEdit: true,
      vueEditorOrganGross: 'vue-editorOrganGrossCustomHeight200',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        /* [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], */
        /* [{ list: 'ordered' }, { list: 'check' }], */
        /* [{ indent: '-1' }, { indent: '+1' }], */
        [{ color: [] }],
        ['clean']
      ],
      editorSettings: {
        fomats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'align',
          'direction',
          'code-block',
          'formula',
          'image',
          'video'
        ],
      },
      sheets: [],
      file: '',
      selectedFile: null,
      laboratoryList: [],
      // add new order item
      newNickName: '',
      newResultItemID: '',
      newResultItemDesc: '',
      newUom: '',
      current_test_item_skey: '',
      isEdit: false
    }
  },
  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('WpOrderItem.newOrderItemLanguage') : this.$t('WpOrderItem.editOrderItemLanguage')
    },
    headers () {
      return [
        // { text: '', align: 'center', value: 'data-table-select' },
        { text: '#', align: 'left', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpResultItem.resultItemId'), value: 'result_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpResultItem.resultItemDesc'), value: 'result_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpResultItem.nickname'), value: 'nickname', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpResultItem.uom'), value: 'uom_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'win_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    offsetAppBar () {
      // return this.getShowAppBar ? 0 : this.getAppBarHeight
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
  },
  async created () {
    await this.retrieveWpResultItem(this.appName)
    await this.retrieveWpUOM(this.appName)
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    async retrieveWpResultItem () {
      console.log('retrieveWpResultItem')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/ResultItem/retrieveWpResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: localStorage.getItem('cust_skey')
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    newItem () {
      this.addEditHeader = this.$t('WpResultItem.addHeader')
      this.newResultItemID = ''
      this.newResultItemDesc = ''
      this.newNickName = ''
      this.newUom = ''
      this.isEdit = false
      this.dialog.dialogAddEdit = true
    },
    async addTestItem (newResultItemID, newResultItemDesc, newNickName, newUom) {
      if (!newResultItemID) {
        await this.$swal({type: 'error', title: this.$t('WpResultItem.idMissing')})
        return
      }
      if (!newResultItemDesc) {
        await this.$swal({type: 'error', title: this.$t('WpResultItem.descMissing')})
        return
      }
      if (!newNickName) {
        await this.$swal({type: 'error', title: this.$t('WpResultItem.nicknameMissing')})
        return
      }
      if (!newUom) {
        await this.$swal({type: 'error', title: this.$t('WpResultItem.uomMissing')})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      if (this.isEdit === false) {
        await this.axios.post(process.env.VUE_APP_API + '/ResultItem/addResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
          result_item_id: newResultItemID,
          result_item_desc: newResultItemDesc,
          nickname: newNickName,
          uom: newUom,
          user: localStorage.getItem('username')
        })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data[0].reasonValue === 1) {
              this.retrieveWpResultItem()
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddEdit = false
            } else {
              this.$swal({type: 'error', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      } else {
        await this.axios.post(process.env.VUE_APP_API + '/ResultItem/editResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
          result_item_id: newResultItemID,
          result_item_desc: newResultItemDesc,
          nickname: newNickName,
          uom: newUom,
          user: localStorage.getItem('username')
        })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data[0].reasonValue === 1) {
              this.retrieveWpResultItem()
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddEdit = false
            } else {
              this.$swal({type: 'error', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      }
      this.dialog.dialogProgress = false
    },
    closeAddnew () {
      this.dialog.dialogAddEdit = false
    },
    async retrieveWpUOM (methodcode) {
      await this.axios.post(process.env.VUE_APP_API + '/ResultItem/retrieveWpUOM' + process.env.VUE_APP_DATABASE_TYPE, {
        Lotskey: methodcode
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.uomList = response.data.data
            // this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            // this.vDataTableCate.data = response.data.data
            // this.initialize()
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpResultItem.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpResultItem.messageDeleteNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var del = []
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('WpOrderItem.progressMessageDelete'), x.order_item_desc)
        var val = await this.deleteNode(x)
        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      this.dialog.dialogProgress = false
    },
    async deleteNode (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/ResultItem/deleteResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
          result_item_id: item.result_item_id
        })
          .then(async response => {
            if (response.data.data[0].reasonValue === 1) {
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.retrieveWpResultItem(this.appName)
            } else {
              await this.$swal({type: 'error', title: response.data.data[0].reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    deleteItemConfirm (item) {
      this.$swal({
        text: this.$t('WpResultItem.confirmDeleteSelected'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          this.deleteNode(item)
        }
      })
    },
    editItem (item) {
      this.addEditHeader = this.$t('WpResultItem.editHeader')
      this.newResultItemID = item.result_item_id
      this.newResultItemDesc = item.result_item_desc
      this.newNickName = item.nickname
      this.newUom = item.uom
      this.isEdit = true
      this.dialog.dialogAddEdit = true
    },
  }
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
#vue-editorOrganGrossCustomHeight200 {
  font-family: Arial, Helvetica, sans-serif;
  width: 768px;
  height: 200px;
  caret-color: black;
}
</style>